import { Tag } from 'antd'

interface EnvironmentBannerProps {
  children: React.ReactNode
}

interface EnvironmentConfig {
  text: string
  bannerColor: string
  textColor: string
}

const getEnvironmentConfig = (env: string): EnvironmentConfig => {
  switch (env.toLowerCase()) {
    case 'tst':
      return { text: 'TST', bannerColor: '#004AAD', textColor: 'white' }
    case 'acc':
      return { text: 'ACC', bannerColor: '#FFDE59', textColor: 'black' }
    case 'dev':
    default:
      return { text: 'DEV', bannerColor: '#7ED957', textColor: 'black' }
  }
}

const EnvironmentBanner = ({ children }: EnvironmentBannerProps): JSX.Element => {
  const env = process.env.REACT_APP_ENVIRONMENT ?? 'prd'

  if (env === 'prd') {
    return <>{children}</>
  }

  const { text, bannerColor, textColor } = getEnvironmentConfig(env)

  return (
    <div>
      {/* This div handles the fixed positioning */}
      <div
        style={{
          position: 'fixed',
          top: '75px',
          right: '100px',
          zIndex: 1050 // A high z-index to be on top of AntD components like modals
        }}
      >
        {}
        <Tag
          color={bannerColor}
          style={{
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: 'TheSans , Arial, sans-serif',
            color: textColor,
            padding: '2px 24px',
            lineHeight: '24px'
          }}
        >
          {text}
        </Tag>
      </div>
      {/* The rest of the application */}
      {children}
    </div>
  )
}

export default EnvironmentBanner
